"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarItem = void 0;
var clsx_1 = __importDefault(require("clsx"));
var permissionManager_1 = require("@common/permissions/permissionManager");
var react_1 = __importDefault(require("react"));
function SideBarItem(_a) {
    var label = _a.label, component = _a.component, domain = _a.domain, isActive = _a.isActive, angularJsDependencies = _a.angularJsDependencies;
    var hrefLink = component === 'app.assignment.csvImporter.step0'
        ? angularJsDependencies.href('app.assignment.csvImporter.step0')
        : angularJsDependencies.href('app.assignment.settings.react', {
            domain: domain,
            component: component,
        });
    return (react_1.default.createElement("li", { className: (0, clsx_1.default)({ active: isActive }) },
        react_1.default.createElement("a", { "data-cy": "link-".concat((0, permissionManager_1.convertRouteForPermission)(permissionManager_1.SETTINGS_ROUTE, { component: component })), href: hrefLink }, label)));
}
exports.SideBarItem = SideBarItem;
